import React from 'react';
import { useTranslation } from 'react-i18next';
import { BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
import SophisticatedTooltipLink from '@wix/da-ds/pkg/tooltips/SophisticatedTooltipLink';
import { DeviationResourceType } from '../../../types/deviation';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import SophisticatedTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SophisticatedTooltip';
import s from './SubscribeToUnlockTooltip.scss';
const TOOLTIP_WIDTH = 144;
const SubscribeToUnlockTooltip = ({ deviation, children, forceVisible, className })=>{
    var _tier, _tier1;
    const { t } = useTranslation();
    const { tier, isTier, isOwner, isUserSubscribed, subscriptionsTabUrl, needsSubscription, isSubscribedButBlocked } = useSubscriptionTier(deviation);
    const isSubscribedTier = isTier && !isOwner && isUserSubscribed;
    const isInASubscribedTier = !isTier && !needsSubscription && !isSubscribedButBlocked;
    if (isSubscribedTier || isInASubscribedTier || !((_tier = tier) === null || _tier === void 0 ? void 0 : _tier.author)) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, children);
    }
    const description = isSubscribedButBlocked ? t('deviation.tier.subscribersOnly.tooltip.lockedSubscribed') : t('deviation.tier.subscribersOnly.tooltip.unsubbed');
    return /*#__PURE__*/ React.createElement(SophisticatedTooltip, {
        className: className,
        size: "large",
        width: TOOLTIP_WIDTH,
        placement: "top",
        "aria-label": description,
        description: description,
        isVisible: forceVisible ? true : undefined,
        postfix: /*#__PURE__*/ React.createElement(SophisticatedTooltipLink, {
            href: subscriptionsTabUrl,
            className: s['subs-link'],
            biData: {
                evid: BiEventType.VIEW_SUBSCRIPTION_TAB,
                referral_info: ReferralType.ACTION_BAR,
                typeid: DeviationResourceType.TIER,
                itemid: (_tier1 = tier) === null || _tier1 === void 0 ? void 0 : _tier1.deviationId
            }
        }, t('deviation.tier.subscribersOnly.tooltip.subscriptionsLink'))
    }, children);
};
SubscribeToUnlockTooltip.displayName = 'SubscribeToUnlockTooltip';
export default SubscribeToUnlockTooltip;
